import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import { useDtpDetailModel } from "./dtpDetailModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Button, message, Modal, Radio } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IOfferExamine } from "@/views/inquires/offer/offerTypes";
import TextArea from "antd/lib/input/TextArea";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const TopButs: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const { editFormVal, insertOrUpdateDtp, getDtpDetailOne, resetPageCache } = useDtpDetailModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        if (!editFormVal.id && mode === "edit") {
            getDtpDetailOne(id)
        }
    }, [mode]);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("9-6-1") && resetPageCache("add")
            !findNav("9-6-2") && resetPageCache("edit");
        }
    }, [selectedNavId])

    const orderStatu: IDescription[] = [
        {
            label: "协议/合同文件",
            value: editFormVal.code ?? "无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: editFormVal.status === 0 ? '已登记' : '已作废',
            color: DescriptionColorEnum.green,
            status: true
        },
        // {
        //     label: "状态",
        //     value: getTreeNodeName(editFormVal.status ?? ""),
        //     color: DescriptionColorEnum.green,
        //     status: true
        // },
    ]


    //表单提交
    const onSubmit = () => {
        formRef.current?.validateFields().then((val: any) => {
            let data = {
                ...val,
                agreementTypeName:getTreeNodeName(val.agreementType),
            }
            insertOrUpdateDtp(mode, data).then(res => {
                if (mode === "add" && res) {
                    resetPageCache("add");
                    replaceNav("9-6-1", "9-6");
                } else if (mode === "edit" && res) {
                    resetPageCache("edit");
                    replaceNav("9-6-2", "9-6");
                }
            })
        }).catch((err: ValidateErrorEntity<any>) => {
            message.warning(getFormValidatorErrText(err));
        })
    };

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.A_A_ED_SAVE}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { onSubmit() }}
            >保存</Button>
        </YhAuth>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "9-6")}
        >返回</Button>
    </>

    return (
        <YhBox
            title={mode === "edit" ? orderStatu.map((item, index) => <Description key={index} {...item} />) : ''}
            style={{ paddingBottom: 0, marginBottom: "10px" }}
            action={action}
        />
    )
}